import React, { FC } from 'react';
import { useRegionsListQuery } from '../api';
import { Select } from '../components/Inputs';
import { ControllerProps } from 'react-hook-form/dist/types/props';

interface Regions extends Pick<ControllerProps<'input'>, 'control' | 'name' | 'rules'> {
  label: string;
  error: boolean | undefined;
}

const Regions: FC<Regions> = ({ label, error, control, name, rules }) => {
  const { data } = useRegionsListQuery();
  return (
    <Select
      label={label}
      data={(data && data.dirRegions) || []}
      control={control}
      error={error}
      name={name}
      rules={rules}
    />
  );
};

export default Regions;
